export default __webpack_public_path__ + "static/media/PendingVote.4a2a520a.svg";